import React from 'react';
import './AnnouncementModal.css';

const AnnouncementModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="announcement-modal-overlay" onClick={onClose}>
      <div className="announcement-modal" onClick={(e) => e.stopPropagation()}>
        <button className="announcement-close" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>

        <div className="announcement-header">
          <div className="announcement-icon">
            <i className="fas fa-bullhorn"></i>
          </div>
          <h2>What's New in PokeMatch!</h2>
          <p className="announcement-subtitle">Check out these exciting new features</p>
        </div>

        <div className="announcement-content">
          <div className="announcement-feature">
            <div className="feature-icon limitless">
              <i className="fas fa-trophy"></i>
            </div>
            <div className="feature-details">
              <h3>Import from Limitless TCG</h3>
              <p>
                Quickly import your tournament matches directly from Limitless!
                Save time by automatically pulling in your deck, opponent info, and match results
                from official tournaments.
              </p>
              <button
                className="feature-cta"
                onClick={() => {
                  onClose();
                  window.location.href = '/import-limitless';
                }}
              >
                <i className="fas fa-arrow-right"></i> Try Import Now
              </button>
            </div>
          </div>

          <div className="announcement-divider"></div>

          <div className="announcement-feature">
            <div className="feature-icon global">
              <i className="fas fa-globe"></i>
            </div>
            <div className="feature-details">
              <h3>Global Analytics Dashboard</h3>
              <p>
                See how you stack up against other players! Explore the global meta, compare your deck performance
                to the global average, and discover which matchups you excel at or need to improve.
              </p>
              <button
                className="feature-cta"
                onClick={() => {
                  onClose();
                  window.location.href = '/analytics/global';
                }}
              >
                <i className="fas fa-arrow-right"></i> View Analytics
              </button>
            </div>
          </div>
        </div>

        <div className="announcement-footer">
          <button className="announcement-dismiss" onClick={onClose}>
            Got it, thanks!
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementModal;
